import { useContent } from "@/context/ContentContext";
import PlanCard from "@/components/PlanCard";
import ExtraInternetTable from "@/components/ExtraInternetTable";
import PagePlacements from "@/components/PagePlacements";

export default function Plans() {
  const { phone_plans, brand } = useContent();
  const heading = brand?.plans_heading || {};
  return (
    <div data-testid="plans-page" className="relative max-w-7xl mx-auto px-6 py-12 md:py-16">
      <div className="max-w-2xl">
        <div className="text-white/70 text-xs uppercase tracking-widest font-semibold">
          {heading.eyebrow || "Abonamenty"}
        </div>
        <h1 data-testid="plans-title" className="font-display text-4xl sm:text-5xl lg:text-6xl font-black text-white mt-3 whitespace-pre-line">
          {heading.title || "Wybierz swój abonament"}
        </h1>
        <p className="text-white/70 mt-4">
          {heading.subtitle || "Płacisz tyle, ile widzisz."}
        </p>
      </div>

      <div className="grid md:grid-cols-2 gap-6 mt-8 max-w-4xl">
        {phone_plans.map((p) => (
          <PlanCard key={p.id} plan={p} />
        ))}
      </div>

      <ExtraInternetTable />
      <PagePlacements page="plans" />
    </div>
  );
}
